import { defineStore } from "pinia";
import { ref } from "vue";

export const useSortingStore = defineStore(
    "sorting",
    () => {
        const files = ref([]);
        const assets = ref([]);
        const tasks = ref({
            desc: true,
        });
        const recurring_tasks = ref([]);

        return {
            files,
            assets,
            tasks,
            recurring_tasks,
        };
    },
    {
        persist: true,
    }
);
